"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Dropdown_1 = __importDefault(require("@Components/Selectors/Dropdown"));
const Button_1 = require("@Components/Buttons/Button");
const get_value_form_1 = require("@App/helpers/get-value-form");
const entities_validators_1 = require("@App/helpers/work-entities/entities-validators");
const creators_1 = require("@App/helpers/work-entities/creators");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const AddAlternativeTitle = ({ closePopupFunc }) => {
    const { workStore, libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [alternativeTitleData, setAlternativeTitleData] = (0, react_1.useState)({
        title: '',
        titleType: null,
        languageCode: null,
    });
    const [validations, setValidations] = (0, react_1.useState)({
        title: {
            required: true,
            maxLength: 500,
        },
        titleType: {
            required: true,
            isNumber: true,
        },
        languageCode: {
            isLanguage: true,
        },
    });
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(true);
    const getValues = (value, id) => {
        const { formObject, validationObject } = (0, get_value_form_1.getValueForm)(value, id, alternativeTitleData, validations);
        setAlternativeTitleData(Object.assign({}, formObject));
        setValidations(Object.assign({}, validationObject));
        checkForm();
    };
    const checkForm = () => {
        setIsDisabled((0, entities_validators_1.formFieldsInvalidCheck)(alternativeTitleData, validations));
    };
    const addAkaTitleToDraft = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedWork = (0, creators_1.createUpdatingWorkDraft)(workDraftFromLocal, 'alternativeTitles', alternativeTitleData);
        workStore.setWorkDraftToLocal(updatedWork);
        closePopupFunc();
    };
    const workDraftToLocal = workStore.workDraftLocal;
    const languageOptions = libStore.languages;
    const titleTypeOptions = libStore.akaTitleTypes;
    if (!alternativeTitleData || !validations || !workDraftToLocal || !languageOptions || !titleTypeOptions) {
        return null;
    }
    const { title, titleType, languageCode } = alternativeTitleData;
    return (react_1.default.createElement("div", { className: "alternative-titles-sub-form-component" },
        react_1.default.createElement("h2", null, "Alternative Titles"),
        react_1.default.createElement("p", { className: "title" },
            react_1.default.createElement("p", { className: 'tooltip' },
                "For full definitions of each Title Type, please click",
                ' ',
                react_1.default.createElement(react_router_dom_1.Link, { className: 'tooltip', to: 'https://help.themlc.com/en/support/what-is-a-title-type', target: "_blank", rel: "noopener noreferrer" }, "here."))),
        react_1.default.createElement("div", { className: "inputs-field" },
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'title', label: 'Alternative Title', assistiveText: 'Required', value: title, onChange: getValues, errorMessage: validations.title.error, required: validations.title.required }),
            react_1.default.createElement(Dropdown_1.default, { options: titleTypeOptions.filter((option) => +option.id !== 1), id: 'titleType', label: 'Title Type', assistiveText: 'Required', mainColor: true, isSearchable: true, isNumberType: true, onChange: getValues, errorMessage: validations.titleType.error, required: validations.titleType.required, selectedValue: titleType ? titleTypeOptions.find((option) => +option.id === titleType) : null }),
            react_1.default.createElement(Dropdown_1.default, { options: languageOptions, id: 'languageCode', label: 'Language', mainColor: true, isSearchable: true, isNumberType: true, onChange: getValues, errorMessage: validations.languageCode.error, required: validations.languageCode.required, selectedValue: languageCode ? languageOptions.find((option) => +option.id === languageCode) : null })),
        react_1.default.createElement("div", { className: 'add-title-container' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: isDisabled, onClick: addAkaTitleToDraft }, "Add Title"))));
};
exports.default = (0, mobx_react_1.observer)(AddAlternativeTitle);
